import React from 'react'

import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers'
import { format as formatDate } from 'date-fns'

import { input } from '@albacross/frontend-utils'

type DatePickerProps = {
  value: any
  onChange: (...args: any[]) => any
  disabled?: boolean
  errorId?: string | boolean
  format?: string
  fullWidth?: boolean
  label?: string
}

const DatePicker = ({
  value,
  onChange,
  disabled = false,
  errorId,
  format = 'yyyy-MM-dd',
  fullWidth = true,
  label = '',
}: DatePickerProps) => (
  <MuiDatePicker
    disabled={disabled}
    format={format}
    label={label}
    onChange={(date: any) => onChange(date ? formatDate(date, format) : '')}
    slotProps={{ textField: { error: !!errorId, fullWidth, helperText: errorId } }}
    value={value ? new Date(value) : null}
  />
)

export default input('')(DatePicker)
